import React, { createContext, ReactNode, useEffect } from "react";
import { abTestingService } from "../../utils/abTestingService";

interface ABTestContextValue {
  service: typeof abTestingService;
}

export const ABTestContext = createContext<ABTestContextValue | undefined>(
  undefined,
);

interface ABTestProviderProps {
  children: ReactNode;
  storageType?: "localStorage" | "cookies";
}

export const ABTestProvider: React.FC<ABTestProviderProps> = ({
  children,
  storageType = "localStorage",
}) => {
  useEffect(() => {
    abTestingService.setStorageType(storageType);
  }, [storageType]);

  return (
    <ABTestContext.Provider value={{ service: abTestingService }}>
      {children}
    </ABTestContext.Provider>
  );
};
